import styled from "@emotion/styled";
import { MDSText, MDSTextVariant, MDSTextColor, MDSIcon, MDSIconKind, MDSIconColor } from "@/mds";
import type { FC } from "react";

interface ImportFooterErrorProps {
  message: string | null;
}

export const ImportFooterError: FC<ImportFooterErrorProps> = ({ message }) => {
  if (!message) {
    return null;
  }

  return (
    <StyledErrorMessage>
      <MDSIcon kind={MDSIconKind.Exclamation} color={MDSIconColor.Danger} />
      <MDSText variant={MDSTextVariant.TextS} color={MDSTextColor.Danger}>
        {message}
      </MDSText>
    </StyledErrorMessage>
  );
};

const StyledErrorMessage = styled.div`
  display: flex;
  align-items: center;
  gap: ${({ theme }) => theme.spacing["2"]};
  padding-left: ${({ theme }) => theme.spacing["3"]};
`;
